const commoncomponent = {
    fourZeroFour: { url: '/404' },
    help: { url: '/help' },
}

const nonAuthedcomponent = {
    login: { url: '/login' },
    resetPassword: { url: '/reset-password' },
    forgotPassword: { url: '/forgot-password' },
    lockScreen: { url: '/lock' },
    sharedDocument: { url: '/s/:token' },
}

const Authedcomponent = {
    inProgress: { url: '/in-progress', permissionId: [] },

    dashboard: { url: '/', permissionId: [] },
    updateProfile: { url: '/profile/update', permissionId: [] },
    updateGlobalSetting: { url: '/global-setting/update', permissionId: [12] },

    logout: { url: '/logout', permissionId: [] },
    addUser: { url: '/user/add', permissionId: [7] },
    listUser: { url: '/user/list', permissionId: [7] },
    editUser: { url: '/user/edit', permissionId: [7] },

    activityLog: { url: '/activity/log', permissionId: [11] },

    mailBox: { url: '/mail', permissionId: [54] },
    mailBoxConfigure: { url: '/mail/configure', permissionId: [53] },

    creatCountryMasterData: { url: '/master-data-management/country/create', permissionId: [] },
    listCountryMasterData: { url: '/master-data-management/country/list', permissionId: [] },
    editCountryMasterData: { url: '/master-data-management/country/edit', permissionId: [] },

    createStateMasterData: { url: '/master-data-management/state/create', permissionId: [32] },
    listStateMasterData: { url: '/master-data-management/state/list', permissionId: [32] },
    editStateMasterData: { url: '/master-data-management/state/edit', permissionId: [32] },

    createDistrictMasterData: { url: '/master-data-management/district/create', permissionId: [33] },
    listDistrictMasterData: { url: '/master-data-management/district/list', permissionId: [33] },
    editDistrictMasterData: { url: '/master-data-management/district/edit', permissionId: [33] },

    createCompanyMasterData: { url: '/master-data-management/company/create', permissionId: [19] },
    listCompanyMasterData: { url: '/master-data-management/company/list', permissionId: [19] },
    editCompanyMasterData: { url: '/master-data-management/company/edit', permissionId: [19] },

    createLeaveTypeMasterData: { url: '/master-data-management/leave-type/create', permissionId: [30] },
    listLeaveTypeMasterData: { url: '/master-data-management/leave-type/list', permissionId: [30] },
    editLeaveTypeMasterData: { url: '/master-data-management/leave-type/edit', permissionId: [30] },

    createExpenseTypeMasterData: { url: '/master-data-management/expense-type/create', permissionId: [31] },
    listExpenseTypeMasterData: { url: '/master-data-management/expense-type/list', permissionId: [31] },
    editExpenseTypeMasterData: { url: '/master-data-management/expense-type/edit', permissionId: [31] },

    createYardMasterData: { url: '/master-data-management/yard/create', permissionId: [17] },
    listYardMasterData: { url: '/master-data-management/yard/list', permissionId: [17] },
    editYardMasterData: { url: '/master-data-management/yard/edit', permissionId: [17] },

    createShipYardMasterData: { url: '/master-data-management/ship-yard/create', permissionId: [18] },
    listShipYardMasterData: { url: '/master-data-management/ship-yard/list', permissionId: [18] },
    editShipYardMasterData: { url: '/master-data-management/ship-yard/edit', permissionId: [18] },

    createShipOwnerMasterData: { url: '/projects-vessels/ship-owner/create', permissionId: [14] },
    listShipOwnerMasterData: { url: '/projects-vessels/ship-owner/list', permissionId: [14] },
    editShipOwnerMasterData: { url: '/projects-vessels/ship-owner/edit', permissionId: [14] },

    createShipMasterData: { url: '/projects-vessels/ship/create', permissionId: [16] },
    listShipMasterData: { url: '/projects-vessels/ship/list', permissionId: [16] },
    editShipMasterData: { url: '/projects-vessels/ship/edit', permissionId: [16] },

    createShipTypeMasterData: { url: '/master-data-management/ship-type/create', permissionId: [20] },
    listShipTypeMasterData: { url: '/master-data-management/ship-type/list', permissionId: [20] },
    editShipTypeMasterData: { url: '/master-data-management/ship-type/edit', permissionId: [20] },

    createBuilderMasterData: { url: '/master-data-management/builder/create', permissionId: [15] },
    listBuilderMasterData: { url: '/master-data-management/builder/list', permissionId: [15] },
    editBuilderMasterData: { url: '/master-data-management/builder/edit', permissionId: [15] },

    createSubContractorMasterData: { url: '/master-data-management/sub-contractor/create', permissionId: [21] },
    listSubContractorMasterData: { url: '/master-data-management/sub-contractor/list', permissionId: [21] },
    editSubContractorMasterData: { url: '/master-data-management/sub-contractor/edit', permissionId: [21] },

    createProjectLocationMasterData: { url: '/master-data-management/project-location/create', permissionId: [23] },
    listProjectLocationMasterData: { url: '/master-data-management/project-location/list', permissionId: [23] },
    editProjectLocationMasterData: { url: '/master-data-management/project-location/edit', permissionId: [23] },

    createSiteLocationMasterData: { url: '/master-data-management/site-location/create', permissionId: [22] },
    listSiteLocationMasterData: { url: '/master-data-management/site-location/list', permissionId: [22] },
    editSiteLocationMasterData: { url: '/master-data-management/site-location/edit', permissionId: [22] },

    createCategoryMasterData: { url: '/master-data-management/category/create', permissionId: [26] },
    listCategoryMasterData: { url: '/master-data-management/category/list', permissionId: [26] },
    editCategoryMasterData: { url: '/master-data-management/category/edit', permissionId: [26] },

    createScheduleCategoryMasterData: { url: '/master-data-management/schedule-category/create', permissionId: [25] },
    listScheduleCategoryMasterData: { url: '/master-data-management/schedule-category/list', permissionId: [25] },
    editScheduleCategoryMasterData: { url: '/master-data-management/schedule-category/edit', permissionId: [25] },

    createCategoryEventMasterData: { url: '/master-data-management/category/event/create', permissionId: [26] },
    listCategoryEventMasterData: { url: '/master-data-management/category/event/list', permissionId: [26] },
    editCategoryEventMasterData: { url: '/master-data-management/category/event/edit', permissionId: [26] },

    createDocumentTypeMasterData: { url: '/master-data-management/document-type/create', permissionId: [29] },
    listDocumentTypeMasterData: { url: '/master-data-management/document-type/list', permissionId: [29] },
    editDocumentTypeMasterData: { url: '/master-data-management/document-type/edit', permissionId: [29] },


    createPlanTypeMasterData: { url: '/master-data-management/plan-type/create', permissionId: [28] },
    listPlanTypeMasterData: { url: '/master-data-management/plan-type/list', permissionId: [28] },
    editPlanTypeMasterData: { url: '/master-data-management/plan-type/edit', permissionId: [28] },

    createRemarkOptionMasterData: { url: '/master-data-management/remark-option/create', permissionId: [26] },
    listRemarkOptionMasterData: { url: '/master-data-management/remark-option/list', permissionId: [26] },
    editRemarkOptionMasterData: { url: '/master-data-management/remark-option/edit', permissionId: [26] },


    leaveApply: { url: '/leave/apply', permissionId: [1] },
    leaveEdit: { url: '/leave/edit', permissionId: [79] },
    leaveApplied: { url: '/leave/applied', permissionId: [1] },
    leaveApplications: { url: '/leave/applications', permissionId: [2] },

    submitNewExpense: { url: '/expense/submit', permissionId: [3] },
    editExpense: { url: '/expense/edit', permissionId: [3] },
    expenseList: { url: '/expense/list', permissionId: [3] },
    expenseApplications: { url: '/expense/applications', permissionId: [4] },

    addProject: { url: '/project/add', permissionId: [13] },
    listProject: { url: '/project/list', permissionId: [13] },
    editProject: { url: '/project/edit', permissionId: [13] },
    assignVesselsToProject: { url: '/project/vessels/assign', permissionId: [13] },

    addRole: { url: '/role/add', permissionId: [8] },
    listRole: { url: '/role/list', permissionId: [8] },
    editRole: { url: '/role/edit', permissionId: [8] },

    addDesignation: { url: '/designation/add', permissionId: [9] },
    listDesignation: { url: '/designation/list', permissionId: [9] },
    editDesignation: { url: '/designation/edit', permissionId: [9] },

    assignModules: { url: '/module/assign', permissionId: [10] },
    listModules: { url: '/module/list', permissionId: [10] },

    submitAppraisalForm: { url: '/appraisal/submit', permissionId: [5] },
    submittedAppraisals: { url: '/appraisal/submitted', permissionId: [5] },

    schedulePreview: { url: '/schedule', permissionId: [25, 60] },
    addEventSchdule: { url: '/event/schedule/add', permissionId: [25] },

    projectDocumentCount: { url: '/document/project', permissionId: [47] },
    shipDocument: { url: '/document/hull', permissionId: [47] },
    addDocument: { url: '/document/add', permissionId: [47] },
    editDocument: { url: '/document/edit', permissionId: [47] },


    submitNewBuildingPreLaunchingCheckList: { url: '/production/submit/new-building-pre-launching-check-list', permissionId: [34] },
    submitNewBuildingPreDeliveryCheckList: { url: '/production/submit/new-building-pre-delivery-check-list', permissionId: [34] },
    submitNewBuildingPreSeaTrialCheckList: { url: '/production/submit/new-building-pre-sea-trial-check-list', permissionId: [34] },
    submitNewBuildingFinalDeliveryDocumentChecksheet: { url: '/production/submit/new-building-final-delivery-document-checksheet', permissionId: [34] },
    submitNewBuildingConfirmationOfVesselCompletionAndDelivery: { url: '/production/submit/confirmation-of-vessel-completion-and-delivery', permissionId: [34] },
    submitNewBuildingBlockInspectionStatus: { url: '/production/submit/block-inspection-status-masterlist', permissionId: [34] },
    submitNewBuildingDailyInspectionReport: { url: '/production/submit/new-building-daily-inspection-report', permissionId: [34] },
    submitNewBuildingNCRIndex: { url: '/production/submit/new-building-ncr-index', permissionId: [34] },
    submitWeeklyTimesheet: { url: '/production/submit/weekly-timesheet', permissionId: [34] },
    submitNewBuildingNCR: { url: '/production/submit/new-building-ncr', permissionId: [34] },


    production: { url: '/production', permissionId: [34] },
    productionReports: { url: '/production/reports', permissionId: [34] },

    siteManagement: { url: '/site-management', permissionId: [] },

    configureNewBuildingPreLaunchingCheckList: { url: '/production/configure/new-building-pre-launching-check-list', permissionId: [73] },
    submittedNewBuildingPreLaunchingCheckList: { url: '/production/submitted/new-building-pre-launching-check-list', permissionId: [34] },

    configureNewBuildingPreDeliveryCheckList: { url: '/production/configure/new-building-pre-delivery-check-list', permissionId: [73] },
    submittedNewBuildingPreDeliveryCheckList: { url: '/production/submitted/new-building-pre-delivery-check-list', permissionId: [34] },

    configureNewBuildingPreSeaTrialCheckList: { url: '/production/configure/new-building-pre-sea-trial-check-list', permissionId: [73] },
    submittedNewBuildingPreSeaTrialCheckList: { url: '/production/submitted/new-building-pre-sea-trial-check-list', permissionId: [34] },

    configureNewBuildingFinalDeliveryDocumentChecksheet: { url: '/production/configure/new-building-final-delivery-document-checksheet', permissionId: [73] },
    submittedNewBuildingFinalDeliveryDocumentChecksheet: { url: '/production/submitted/new-building-final-delivery-document-checksheet', permissionId: [34] },

    submittedNewBuildingBlockInspectionStatus: { url: '/production/submitted/block-inspection-status-masterlist', permissionId: [34] },


    submittedNewBuildingConfirmationOfVesselCompletionAndDelivery: { url: '/production/submitted/confirmation-of-vessel-completion-and-delivery', permissionId: [34] },

    submittedNewBuildingDailyInspectionReport: { url: '/production/submitted/new-building-daily-inspection-report', permissionId: [34] },



    submittedNewBuildingNCRIndex: { url: '/production/submitted/new-building-ncr-index', permissionId: [34] },

    submittedWeeklyTimeSheet: { url: '/production/submitted/weekly-timesheet', permissionId: [34] },

    submittedNewBuildingNCR: { url: '/production/submitted/new-building-ncr', permissionId: [34] },

    submitOwnerDefectReport: { url: '/production/submit/owner-defect-report', permissionId: [34] },
    submittedOwnerDefectReport: { url: '/production/submitted/owner-defect-report', permissionId: [34] },


    pendingBlockInspection: { url: '/production/pending/block-inspection-status-masterlist', permissionId: [34] },
    pendingVesselConfirmation: { url: '/production/pending/confirmation-of-vessel-completion-and-delivery', permissionId: [34] },
    pendingDailyInspection: { url: '/production/pending/daily-inspection-report', permissionId: [34] },
    pendingNCRIndex: { url: '/production/pending/non-conformity-report-index', permissionId: [34] },
    pendingNCR: { url: '/production/pending/non-conformity-report', permissionId: [34] },
    pendingOwnerDefect: { url: '/production/pending/owner-defect-report', permissionId: [34] },
    pendingWeeklyTimesheet: { url: '/production/pending/weekly-time-sheet', permissionId: [34] },


    pendingSiteQueryReportIndex: { url: '/site-management/pending/site-query-report-index', permissionId: [35] },
    pendingSiteAuditIndex: { url: '/site-management/pending/site-audit-index', permissionId: [35] },
    pendingVOIndexRegister: { url: '/site-management/pending/p-vo-index-register', permissionId: [35] },
    pendingCustomerPropertyInventory: { url: '/site-management/pending/customer-property-inventory', permissionId: [35] },
    pendingSiteQueryForm: { url: '/site-management/pending/site-query-form', permissionId: [35] },
    pendingShipyardevaluationofshipyardperformance: { url: '/site-management/pending/shipyard-evaluation-of-shipyard-performance', permissionId: [35] },
    pendingVariationOrderForm: { url: '/site-management/pending/potential-variation-order-form', permissionId: [35] },

    submitNewBuildingSiteQueryReportIndex: { url: '/site-management/submit/new-building-site-query-report-index', permissionId: [35] },
    submittedNewBuildingSiteQueryReportIndex: { url: '/site-management/submitted/new-building-site-query-report-index', permissionId: [35] },

    submitNewBuildingSiteQueryForm: { url: '/site-management/submit/new-building-site-query-form', permissionId: [35] },
    submittedNewBuildingSiteQueryForm: { url: '/site-management/submitted/new-building-site-query-form', permissionId: [35] },

    submitNewBuildingPotentialVariationOrderForm: { url: '/site-management/submit/new-building-potential-variation-order-form', permissionId: [35] },
    submittedNewBuildingPotentialVariationOrderForm: { url: '/site-management/submitted/new-building-potential-variation-order-form', permissionId: [35] },

    submitNewBuildingCustomerPropertyInventoryForm: { url: '/site-management/submit/new-building-customer-property-inventory-form', permissionId: [35] },
    submittedNewBuildingCustomerPropertyInventoryForm: { url: '/site-management/submitted/new-building-customer-property-inventory-form', permissionId: [35] },

    submitNewBuildingSiteAuditIndex: { url: '/site-management/submit/new-building-site-audit-index-form', permissionId: [35] },
    submitPotentialVariationOrderIndexRegister: { url: '/site-management/submit/new-building-potential-variation-order-index-register-form', permissionId: [35] },

    submitShipyardEvaluationPerformance: { url: '/site-management/submit/shipyard-evaluation-perfomance', permissionId: [35] },
    submittedShipyardEvaluationPerformance: { url: '/site-management/submitted/shipyard-evaluation-perfomance', permissionId: [35] },

    submitFatReport: { url: '/site-management/submit/fat-report', permissionId: [35] },
    submittedFatReport: { url: '/site-management/submitted/fat-report', permissionId: [35] },

    submitBiWeeklyReport: { url: '/site-management/submit/bi-weekly-report', permissionId: [35] },
    submittedBiWeeklyReport: { url: '/site-management/submitted/bi-weekly-report', permissionId: [35] },

    submitMonthlyReport: { url: '/site-management/submit/monthly-report', permissionId: [35] },
    submittedMonthlyReport: { url: '/site-management/submitted/monthly-report', permissionId: [35] },

    submitDrawingList: {
        url: '/site-management/submit/drawing-list',
        permissionId: [35]
    },
    submittedDrawingList: {
        url: '/site-management/submitted/drawing-list',
        permissionId: [35]
    },

    submitOwnerNCR: {
        url: '/site-management/submit/owner-ncr',
        permissionId: [35]
    },
    submittedOwnerNCR: {
        url: '/site-management/submitted/owner-ncr',
        permissionId: [35]
    },

    submitListOfReferenceBooksAndPublication: {
        url: '/site-management/submit/reference-books-publication',
        permissionId: [35]
    },
    submittedListOfReferenceBooksAndPublication: {
        url: '/site-management/submitted/reference-books-publication',
        permissionId: [35]
    },

    planApprovalIndex: { url: '/plan-approval', permissionId: [45, 56] },
    planApprovalCreate: { url: '/plan-approval/create', permissionId: [45] },
    planApprovalProject: { url: '/plan-approval/project', permissionId: [45, 56] },
    planApprovalDetail: { url: '/plan-approval/detail', permissionId: [45, 56] },

    fatIndex: { url: '/fat', permissionId: [39, 59] },
    fatCreate: { url: '/fat/create', permissionId: [39] },
    fatEdit: { url: '/fat/edit', permissionId: [39] },

    fatDetail: { url: '/fat/detail', permissionId: [39, 59] },
    fatProject: { url: '/fat/project', permissionId: [39, 59] },

    ncrIndex: { url: '/ncr', permissionId: [41, 58] },
    ncrList: { url: '/ncr/hull', permissionId: [41, 58] },
    ncrCreate: { url: '/ncr/create', permissionId: [41] },
    ncrCreateComment: { url: '/ncr/create/comment', permissionId: [41] },
    ncrDetail: { url: '/ncr/detail', permissionId: [41, 58] },

    inspectionIndex: { url: '/inspection', permissionId: [43, 57] },
    inspectionProject: { url: '/inspection/project', permissionId: [43, 57] },
    inspectionCreate: { url: '/inspection/create', permissionId: [43] },
    inspectionEdit: { url: '/inspection/edit', permissionId: [43] },



    finalDrawingIndex: { url: '/final-drawing', permissionId: [29] },
    finalDrawingDetail: { url: '/final-drawing/detail', permissionId: [29] },
    createDrawing: { url: '/final-drawing/create', permissionId: [29] },
    editDrawing: { url: '/final-drawing/edit', permissionId: [29] },


    createChannelMasterData: { url: '/master-data-management/channel/create', permissionId: [24] },
    listChannelMasterData: { url: '/master-data-management/channel/list', permissionId: [24] },
    editChannelMasterData: { url: '/master-data-management/channel/edit', permissionId: [24] },

    projectGuarantyClaimCount: { url: '/guaranty-claim/project', permissionId: [51] },
    shipGuarantyClaims: { url: '/guaranty-claim/hull', permissionId: [51] },
    createNewGuarantyClaim: { url: '/guaranty-claim/create', permissionId: [51] },


    attendanceProjectList: { url: "/attendance/project", permissionId: [] },
    myAttendance: { url: "/attendance", permissionId: [] },
    attendanceCreate: { url: "/attendance/submit", permissionId: [80] },
    attendanceEdit: { url: "/attendance/edit", permissionId: [80] },
    attendanceMonthlyReport: { url: "/attendance/monthlyReport/project", permissionId: [] },
    attendanceMonthlyReportUser: { url: "/attendance/monthlyReport/user", permissionId: [] },

    microsoftAuthCallback: { url: "/auth/callback", permissionId: [] },

    manual: { url: "/manual", permissionId: [] },

}


const keys = {
    globalDetails: 'iship_nb_gd.iship.com',
    userDetails: 'iship_nb_ud.iship.com',
    userToken: 'iship_nb_tk.iship.com',
    userModule: 'iship_nb_um.iship.com',
    forgorPassword: 'iship_nb_fp.iship.com',
    mailFolder: 'iship_nb_mf.iship.com',
    mailBox: 'iship_nb_mb.iship.com',
    notificationFeed: 'iship_nb_nf.iship.com',
    mailboxUnreadSnapshot: 'iship_nb_mus.iship.com',
    chatNotificationCursor: 'iship_nb_cnc.iship.com'


}

// Per-action permissions on the Production / Site Management modules, ticked per
// designation in Master Modules. Ids are pinned by
// db/2026-09-14_form_soft_delete_and_action_permissions.sql in the API repo and
// enforced there too — hiding a button is not the security boundary.
const actionPermission = {
    productionDeleteForm: 72,
    productionConfigureForm: 73,
    productionExportReport: 74,
    siteManagementDeleteForm: 75,
    siteManagementConfigureForm: 76,
    siteManagementExportReport: 77,
    scheduleDeleteEvent: 78,
    leaveEditApplication: 79,
    attendanceManageRecords: 80,
}

export default { keys, commoncomponent, nonAuthedcomponent, Authedcomponent, actionPermission }
